/* React */
import React from "react";

/* Ionic */
import { IonRange } from "@ionic/react";

/* Components */
import FilterLabel from "src/components/shared/labels/filter-label/FilterLabel";
import ValueContainer from "src/components/shared/slider/simple-slider/value-container/ValueContainer";

/* Stylesheet */
import styles from "./SimpleSlider.module.scss";

/* Interfaces */
interface SimpleSliderProps {
  scssProps?: ScssProps;
  className?: string;
  label?: string;
  min: number;
  max: number;
  ticks?: boolean;
  snaps?: boolean;
  pin?: boolean;
  dualKnobs?: boolean;
  value: number;
  disabled?: boolean;
  onChange: (value: number) => void;
}

interface ScssProps {
  padding?: string;
  margin?: string;
}

const SimpleSlider: React.FC<SimpleSliderProps> = ({
  scssProps,
  className,
  label,
  min,
  max,
  ticks,
  snaps,
  pin,
  dualKnobs,
  value,
  disabled,
  onChange,
}) => {
  return (
    <div
      style={{
        padding: scssProps?.padding,
        margin: scssProps?.margin,
      }}
      className={styles.simple_slider}
    >
      <FilterLabel label={label!} />
      <IonRange
        className={`${styles.slider} ${
          disabled ? styles.disabled : styles[className!]
        }`}
        min={min}
        max={max}
        ticks={ticks}
        snaps={snaps}
        value={value}
        pin={pin}
        pinFormatter={(value) => value}
        dualKnobs={dualKnobs}
        disabled={disabled}
        onIonChange={(e) =>
          onChange(e.detail.value as number)
        }
      />
      <ValueContainer min={min} max={max} />
    </div>
  );
};

export default SimpleSlider;
